import React from 'react';
import { DTOrderSearchView } from '../../DTOrderSearchView';
import { processOrderItemsPartialRefund } from '../../../../../../actions/tools/DecisionTree/OrderActions';
import { useDispatch, useSelector } from 'react-redux';
import { hasLineItemsInOrderSelected } from '../../../../../../selectors/tools';
import { selectSearchPageLoading } from '../../../../../../selectors/searchPage';
import { CustomNoResultsComponentContextProvider } from '../../Common/NoSearchResults/CustomNoResultsComponentContext';
import { DTNoResultsLink } from '../../../../Common/DTNoResultsLink/DTNoResultsLink';

const DTSelectOrderItemsForPartialRefundNode = () => {
  const dispatch = useDispatch();
  const hasLineItemsSelected = useSelector(hasLineItemsInOrderSelected);
  const isLoading = useSelector(selectSearchPageLoading);

  const handleNextButtonClick = () => {
    dispatch(processOrderItemsPartialRefund());
  };

  return (
    <CustomNoResultsComponentContextProvider value={<DTNoResultsLink />}>
      <DTOrderSearchView
        onNextButtonClick={handleNextButtonClick}
        isNextButtonActive={hasLineItemsSelected && !isLoading}
      />
    </CustomNoResultsComponentContextProvider>
  );
};

export default DTSelectOrderItemsForPartialRefundNode;
